import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import DatePicker from 'react-date-picker';
//import DatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';


//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const AddNotification: FC = () => {
  const intl = useIntl()

  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10; // Per page show the data pagination
  const Pagesize = 10;
  const red = "red";
  const [totalItems, setTotalItems] = useState(0);
  const [categories, setCategories] = useState([]);
  const [totalpages, settotalPages] = useState(0);
  const [adminProfileList, setAdminProfileList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventInfo, setEventInfo] = useState([]);
  const [notificationInfo, setNotificationInfo] = useState<any>([]);

  const siteId = '2';
  const location99 = useLocation();

  const queryParams99 = new URLSearchParams(location99.search);
  const eventId = queryParams99.get('eventId');
  const notificationId = queryParams99.get('notificationId');

  const [stateData, setStateData] = useState([]);
  const [ckeventInfo, setckEventInfo] = useState<any>('');

  const [eventStartDate, setEventStartDate] = useState(new Date());
  const [eventEndDate, setEventEndDate] = useState(new Date());

  //const [notificationStartDate, setNotificationStartDate] = useState(new Date());
  //const [notificationEndDate, setNotificationEndDate] = useState(new Date());

  const [notificationStartDate, setNotificationStartDate] = useState<any>(new Date());
  const [notificationEndDate, setNotificationEndDate] = useState<any>(new Date());

  let history = useHistory();

  //const eventId = '5';
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function getIndustries() {

    services.getIndustryData().then((res) => {
      //console.log(JSON.stringify(res)); 

      if (res.data) {
        setCategories(res.data.content);
      }
    });
  }

  function handleChangeEventInfoDesc(content) {
    setckEventInfo(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }


  function onChangeEventStartDate() {


  }

  function onChangeEventEndDate() {


  }





  const submitValue = () => {

    var validateEditorTxt = 1;
    if ($('#notification_title').val() == "") {
      $("#notification_title_validMsg").show();
      $(window).scrollTop($('#notification_title_validMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notification_title_validMsg").hide();
    }
    //alert(notificationStartDate.toDateString());
    //alert(notificationStartDate.toDateString());

    if (notificationStartDate == "") {
      $("#notificationStartdateValidMsg").show();
      $(window).scrollTop($('#notificationStartdateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notificationStartdateValidMsg").hide();
    }


    if (new Date(notificationStartDate) > new Date(notificationEndDate)) {
      $("#dateValidMsg").show();
      $(window).scrollTop($('#dateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#dateValidMsg").hide();
    }

    if (ckeventInfo == "") {
      $("#notificationInfoValidMsg").show();
      $(window).scrollTop($('#notificationInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notificationInfoValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }
    var notification_title = $("#notification_title").val();

    const requestObject = {
      "siteId": "2",
      "notificationId": notificationId,
      "notificationTitle": notification_title,
      "notificationDescription": ckeventInfo,
      "startDate": notificationStartDate,
      "endDate": notificationEndDate

    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminCreateNotification(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#addnotificationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addnotificationsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/notificationlist');
        }, 1000);
      }
      else {
        $("#addnotificationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addnotificationfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);
      }

    });

  }
  useEffect(() => {

    //const queryParams2 = new URLSearchParams(location99.search);
    //const eventIdGet = queryParams2.get('eventId');
    //const notificationIdGet = queryParams2.get('notificationId');
    $("#notification_title_validMsg").hide();
    $(".se-dialog-tabs").hide();
    $("#notificationInfoValidMsg").hide();
    //$("#eventInfoValidMsg").hide();
    //$('#eventtitleValidMsg').hide();
    $('#dateValidMsg').hide();
    $('#notificationStartdateValidMsg').hide();
    $("#addnotificationsuccessMessage").hide();
    $('#addnotificationfailMessage').hide();
    //$('#dateValidMsg').hide();
  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>Create Notification</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>

        <div className="container">
          <div className="row">


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Notification Title</label>

                </div>

                <input type="text" id="notification_title" name="notification_title" className="form-control" placeholder="" />
                <div id="notification_title_validMsg" style={{ color: red }} className="error">Notification Title is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Even Start Date</label>

                </div>
                {/* <input type="text" id="event_date" name="event_date" className="form-control" placeholder="" />
                <div id="eventdateValidMsg" style={{ color: red }} className="error">Event Date is required.</div> */}



                <div>
                  {/* <DatePicker className="form-control react-date-picker eventStartDateCls"
                selected={setNotificationStartDate}
                 onChange={(date) => setNotificationStartDate(date)}
                 /> */}

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={notificationStartDate}
                    onChange={(date) => setNotificationStartDate(date)}

                  />
                  <div id="notificationStartdateValidMsg" style={{ color: red }} className="error">Event Start Date is required.</div>

                </div>


              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Event End Date</label>

                </div>

                <div>

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={notificationEndDate}
                    onChange={(date) => setNotificationEndDate(date)}

                  />
                  <div id="dateValidMsg" style={{ color: red }} className="error">Notification End Date should not be less than Start Date.</div>
                  {/* <DatePicker className="form-control react-date-picker" onChange={setEventEndDate} 
                  value={setNotificationStartDate} 
                  selected={eventEndDate}
                  /> */}
                </div>

              </div>
            </div>






            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Notification Information</label>
                </div>
                {/* <h1>this is FCK editor area</h1> */}

                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="notificatiionInfoId"
                  data={notificationInfo.notificationDescription}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setckEventInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeEventInfoDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="notificationInfoValidMsg" style={{ color: red }} className="error">Notification Information is required.</div>
              </div>
            </div>






            <div className="col-lg-12">
              <div className="mb-4">
                <div className="d-flex flex-column ">

                  <div className="row mt-8">






                    <div className="divider"></div>

                    <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Add Notification </button>



                  </div>
                </div>
                <div id="addnotificationsuccessMessage" className="alert alert-success" role="alert">Notification Added Successfully</div>
                <div id="addnotificationfailMessage" className="alert alert-danger" role="alert">Please try again</div>

              </div>
            </div>

          </div>
        </div>
      </form>
    </>
  )
}
export { AddNotification }